import moment from 'moment';
import { luftGet } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// actions
const GET_MANIFESTS_IN_TRANSIT = 'luft/on-time/GET_MANIFESTS_IN_TRANSIT';
const GET_MANIFESTS_IN_TRANSIT_SUCCESS =
  'luft/on-time/GET_MANIFESTS_IN_TRANSIT_SUCCESS';
const GET_MANIFESTS_IN_TRANSIT_FAILURE =
  'luft/on-time/GET_MANIFESTS_IN_TRANSIT_FAILURE';

// reducer

const initialState = {
  isFetching: false,
  error: '',
  requested: '',
  list: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_MANIFESTS_IN_TRANSIT:
      return {
        ...state,
        isFetching: true,
        error: '',
        requested: moment().format('YYYY-MM-DD HH:mm:ss'),
      };

    case GET_MANIFESTS_IN_TRANSIT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: '',
        list: action.list.manifestsInTransit,
      };

    case GET_MANIFESTS_IN_TRANSIT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
}

export default reducer;

// actions creators

function _getManifestsInTransit() {
  return { type: GET_MANIFESTS_IN_TRANSIT };
}

function _getManifestsInTransitSuccess(list) {
  return {
    type: GET_MANIFESTS_IN_TRANSIT_SUCCESS,
    list,
  };
}

function _getManifestsInTransitFailure(error) {
  return {
    type: GET_MANIFESTS_IN_TRANSIT_FAILURE,
    error,
  };
}

// thunk action creators

export function getManifestsInTransit(params) {
  return async function (dispatch) {
    return (async () => {
      dispatch(_getManifestsInTransit());

      try {
        const response = await luftGet('/OnTime/GetManifests', params); // old GetManifestsInTransit

        dispatch(_getManifestsInTransitSuccess(response.data));
        return response.data;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getManifestsInTransitFailure(error.message),
        );
      }
    })();
  };
}
